// extracted by mini-css-extract-plugin
module.exports = {"nodeHeader":"NodeBody_nodeHeader__nS9xE","nodeBody":"NodeBody_nodeBody__2fjoo"};